import { create } from "zustand";
import { BufferGeometry, Matrix4, Vector3 } from "three";

export type FootSide = 'right' | 'left';

export interface FootMeshData {
    fileName: string;
    geometry: BufferGeometry;
    // Picked points in the geometry's local (file) coordinates.
    points: Vector3[];
    // Geometry and points are already placed on the insole (loaded from the design): shown as is,
    // without automatic alignment.
    placed?: boolean;
}

export const FOOT_POINTS_COUNT = 3;

interface FootMeshStore {
    rightFoot: FootMeshData | null;
    leftFoot: FootMeshData | null;
    // Manual transform per foot [right, left], set with the align foot transform controls.
    // Relative to the foot's automatic placement, so it follows insole edits.
    adjustments: (Matrix4 | null)[];
    // Incremented when the user applies feet in the panel; the viewer saves them to the design.
    saveRequest: number;
    setFoot: (side: FootSide, foot: FootMeshData | null) => void;
    applyFeet: (rightFoot: FootMeshData | null, leftFoot: FootMeshData | null) => void;
    applyAdjustments: (adjustments: (Matrix4 | null)[]) => void;
}

export const useFootMeshStore = create<FootMeshStore>((set) => ({
    rightFoot: null,
    leftFoot: null,
    adjustments: [null, null],
    saveRequest: 0,
    setFoot: (side, foot) => set(side === 'right' ? { rightFoot: foot } : { leftFoot: foot }),
    applyFeet: (rightFoot, leftFoot) => set(state => ({ rightFoot, leftFoot, adjustments: [null, null], saveRequest: state.saveRequest + 1 })),
    applyAdjustments: (adjustments) => set(state => ({ adjustments, saveRequest: state.saveRequest + 1 })),
}));
